import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { Suspense, useContext, useMemo, useState, } from 'preact/compat';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { componentDefault, OptionsCTX, } from '@widgets/AccountPage/types/Options';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
import AccountHeader from '@widgets/AccountPage/components/AccountHeader';
import UsefulLinks from '@widgets/shared/components/UsefulLinks';
import AccountForm from '@widgets/AccountForm';
import ChangePasswordForm from '@widgets/ChangePasswordForm';
import { DummyLink } from '@widgets/GenericBookings/components/AttendeesSelector/styles/SelectedAttendees';
import Bookings from '@widgets/AccountPage/components/Bookings';
import GiftVoucherForm from '@widgets/GiftVoucherForn';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { accountPageStore } from '@widgets/AccountPage/store';
import { useAppDispatch } from '@widgets/AccountPage/store/hooks';
import { useCallback } from 'react';
import { setActiveBookings, setPastBookings } from '@widgets/AccountPage/store/reducers/bookings';
import useDidMount from 'beautiful-react-hooks/useDidMount';
function Element() {
    const { currentTab: initialTab, securityIcon, bookingsIcon, detailsIcon, giftVouchersIcon, securityTitle, bookingsTitle, detailsTitle, giftVouchersTitle, usefulLinks, usefulLinkTitle, accountFormDefaults, resetPasswordDefaults, giftVoucherDefaults, activeBookings, pastBookings, } = useContext(OptionsCTX);
    const [activeTab, setActiveTab] = useState(initialTab);
    const dispatch = useAppDispatch();
    const handleMount = useCallback(() => {
        dispatch(setActiveBookings(activeBookings));
        dispatch(setPastBookings(pastBookings));
    }, [activeBookings, pastBookings]);
    const mount = useDidMount(handleMount);
    const activeHeader = useMemo(() => {
        switch (activeTab) {
            case 'Bookings':
                return {
                    icon: bookingsIcon,
                    title: bookingsTitle,
                };
            case 'Gift Vouchers':
                return {
                    icon: giftVouchersIcon,
                    title: giftVouchersTitle,
                };
            case 'Security':
                return {
                    icon: securityIcon,
                    title: securityTitle,
                };
            case 'Details':
            default:
                return {
                    icon: detailsIcon,
                    title: detailsTitle,
                };
        }
    }, [activeTab]);
    const element = useMemo(() => {
        switch (activeTab) {
            case 'Bookings':
                return (_jsx(Bookings, {}));
            case 'Gift Vouchers':
                return (_jsx("div", { className: "form__section", children: _jsx(GiftVoucherForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        dataset: { ...giftVoucherDefaults } }) }));
            case 'Security':
                return (_jsxs("div", { className: "form__section", children: [_jsx(ChangePasswordForm
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            dataset: { ...resetPasswordDefaults } }), _jsxs("p", { children: [_jsx("span", { children: "You can also " }), _jsx(DummyLink, { onClick: () => {
                                        window.dispatchEvent(new CustomEvent('logout.open', {
                                            detail: true,
                                        }));
                                    }, children: "sign out of all active sessions" })] })] }));
            case 'Details':
            default:
                return (_jsx(AccountForm
                // @ts-ignore
                , { 
                    // @ts-ignore
                    dataset: { ...accountFormDefaults } }));
        }
    }, [activeTab]);
    return (_jsxs(_Fragment, { children: [_jsx(AccountHeader, { activeTab: activeTab, onHandleTabChange: (tab) => setActiveTab(tab) }), _jsx("div", { className: "section form", children: _jsxs("div", { className: "container container--small", children: [_jsxs("h3", { className: "form__title", children: [_jsx("svg", { children: _jsx("use", { xlinkHref: `#icon--${activeHeader.icon}` }) }), _jsx("span", { children: activeHeader.title })] }), _jsxs("div", { className: "rfx-grid padding-large", children: [_jsx("div", { className: "rfx-col-md-7", children: element }), _jsx("div", { className: "rfx-col-md-5", children: _jsx(UsefulLinks, { usefulLinks: usefulLinks, title: usefulLinkTitle }) })] })] }) })] }));
}
function AccountPage(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formConfig = useMemo(() => ({
        ...componentDefault,
        ...formattedAttributes,
    }), [formattedAttributes]);
    const store = configureStore({
        ...accountPageStore,
    });
    return (_jsx(Provider, { store: store, children: _jsx(Suspense, { fallback: LoadingSpinner, children: _jsx(OptionsCTX.Provider, { value: formConfig, children: _jsx(Element, {}) }) }) }));
}
export default AccountPage;
